import { Component, Input } from '@angular/core';
import { BaseComponent } from 'base-form';

@Component({
  selector: 'mfpc-datepicker',
  templateUrl: './datepicker.component.html',
  styleUrls: ['./datepicker.component.scss']
})
export class DatepickerComponent extends BaseComponent {
  minDate: Date;

  maxDate: Date;

  @Input() set min(value: any) {
    if (value) {
      this.minDate = new Date(value);
    }
  };

  @Input() set max(value: any) {
    if (value) {
      this.maxDate = new Date(value);
    }
  };
}
